

















import axios from 'axios';
import { Component, Vue } from 'vue-property-decorator';

import { OrderItem } from '@/models/order/OrderItem';

import ChatPanel from '@/components/App/OrderPanels/ChatPanel.vue';
import OrderPanel from '@/components/App/OrderPanels/OrderPanel.vue';
import SumPanel from '@/components/App/OrderPanels/SumPanel.vue';

@Component({
    components: {
        'app-chat-panel': ChatPanel,
        'app-order-panel': OrderPanel,
        'app-sum-panel': SumPanel,
    }
})
export default class Order extends Vue {
    public order: OrderItem|null = null;

    public fetchOrder () {
        axios.get(`order/${this.$route.params.id}`)
            .then((response) => {
                this.order = response.data;
            })
            .catch((error) => {
                this.$store.dispatch('shared/error', error.response);
            });
    }

    public created () {
        this.fetchOrder();
    }
}
